export enum OrderSource {
	WALLET = 'WALLET',
	TRADING_ACCOUNT = 'TRADING_ACCOUNT',
}
